import gql from 'graphql-tag';
import { eventTypeGQLFields } from './eventType.fields.js';
export const globalEventTypesQuery = (fields) => gql `
  query globalEventTypes {
    globalEventTypes {
      ${eventTypeGQLFields(fields)}
    }
  }
`;
